export * from './lib/regional-config-variables';
